var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ListingTableFilter", {
    attrs: {
      filter: _vm.filter,
      valuesHumanized: _vm.appliedFilterLabels,
      filterConfig: _vm.filterConfig
    },
    on: {
      updateFilter: _vm.updateFilter,
      updateVisibility: _vm.updateVisibility,
      removeFilter: _vm.removeFilter
    },
    scopedSlots: _vm._u([
      {
        key: "filterDropdownContent",
        fn: function() {
          return [
            _c("CompassDropdownOption", {
              staticClass: "listing-filter-dropdown-search-empty",
              attrs: { value: "emptyOption", label: "emptyOption" }
            }),
            _vm._v(" "),
            _c("CompassInput", {
              staticClass: "listing-filter-dropdown-search-input",
              attrs: { placeholder: _vm.$t.__("common.labels.search") },
              on: { change: _vm.updateFilter },
              scopedSlots: _vm._u([
                {
                  key: "suffix",
                  fn: function() {
                    return [
                      _c("CompassIcon", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.hasSearchValue,
                            expression: "hasSearchValue"
                          }
                        ],
                        staticClass: "listing-filter-dropdown-search-reset",
                        attrs: { icon: "close", type: "primary" },
                        on: { click: _vm.clearSearch }
                      })
                    ]
                  },
                  proxy: true
                }
              ]),
              model: {
                value: _vm.searchValue,
                callback: function($$v) {
                  _vm.searchValue = $$v
                },
                expression: "searchValue"
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }